import { post, get } from "@utils/httpUtil";
// 处方模版分页
export function prescriptionTemplateTemplatePage(data, config) {
  return post(`/c/pc/prescription/template/templatePage`, data, config);
}
// 处方模版更新创建
export function prescriptionTemplateCreateTemplate(data, config) {
  return post(`/c/pc/prescription/template/createTemplate`, data, config);
}
// 处方模版详情
export function prescriptionTemplateFindTemplateById(data, config) {
  return get(`/c/pc/prescription/template/findTemplateById`, data, config);
}
// 处方模版删除
export function prescriptionTemplateRemoveTemplates(data, config) {
  return post(`/c/pc/prescription/template/removeTemplates`, data, config);
}
// 查询疾病标签
export function prescriptionTemplateFindDiagnosisPage(data, config) {
  return post(`/c/pc/prescription/template/findDiagnosisPage`, data, config);
}
//查询社区药品列表
export function deliverCommunityUserCommunityDoctorGoods(data, config) {
  data.parentCatalogCode = 1000;
  return post(`/c/pc/deliver/communityUser/communityDoctorGoods`, data, config);
}
//查询社区药品列表
export function deliverDrugPage(data, config) {
  data.parentCatalogCode = data.parentCatalogCode || 1000;
  return post(`/c/pc/deliver/drug/page`, data, config);
}
export function prescriptionTemplateNameCheck(data, config) {
  return post(`/c/pc/prescription/template/templateNameCheck`, data, config);
}
//getDrugFrequencyData
export function getDrugFrequencyData(data, config) {
  return get(`/c/pc/prescription/template/getDrugFrequencyData`, data, config);
}
//getDrugFrequencyData
export function getMedicationMethodList(data, config) {
  return get(`/c/pc/prescription/template/getMedicationMethodList`, data, config);
}